import Label from '@/ui/components/Form/Label';
import { Props } from '@/ui/components/Form/Textarea/types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Textarea = ({
  autoCorrect = 'on',
  cols = 30,
  disabled = false,
  id,
  labelText,
  name,
  onBlur,
  onChange,
  placeholder,
  readOnly = false,
  spellCheck = true,
  value,
  rows
}: Props) => {
  return (
    <>
      <Label htmlFor={id} text={labelText}>
        <textarea
          autoCorrect={autoCorrect}
          className="block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          cols={cols}
          disabled={disabled}
          id={id}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          placeholder={placeholder || labelText}
          readOnly={readOnly}
          spellCheck={spellCheck}
          value={value}
          rows={rows}
        />
      </Label>
    </>
  );
};

export default Textarea;
